export default __webpack_public_path__ + "assets/ghana-flag.png";